/**
 * Created by zhengyf on 2017/12/15.
 **/

;(function() {

    rfqSearchCtrl.$inject = ['request', 'rfqLoadAccInfoFactory'];
    angular
        .module('DSSXAPP')
        .component('rfqSearch', {
            template:'<div class="rfq-search-component next-row next-row-no-padding nav-bar-row"><div class="next-col next-col-fixed-10"><div class="category"><div class="bc-brh-categories"><i class="iconfont icon-category"></i><i class="iconfont icon-moreunfold"></i><h3><a href="javascript:;">Categories</a></h3></div></div></div><div class="next-col-searchbar"><div class="searchbar"><input class="bc-text" placeholder="请输入关键词搜索RFQ" ng-model="vm.d.searchKey" ng-keydown="vm.f.enterSearchBusiness($event)"><div class="search-btn-wrap" ng-click="vm.f.searchBusiness()"><input type="submit" class="bc-searchbar-submit" value="Search"> <i></i></div></div></div><div class="next-col next-col-fixed-9"><div class="my-search-wrapper"><div class="bc-brh-my-search"><i class="iconfont icon-moreunfold"></i><h3><a href="javascript:;"><span>我定制的搜索</span> <span>(</span> <span ng-bind="vm.d.customizeSearchKey.length"></span> <span>)</span></a></h3></div><ul class="bc-brh-my-search-content"><li class="bc-brh-my-search-c-title"><span>通知方式：</span> <span>旺旺</span></li><li class="my-search-divider"></li><li class="brh-list-content-wrap"><ul class="brh-list-content"><li class="list-item" ng-repeat="key in vm.d.customizeSearchKey track by $index"><a href="javascript:;" ng-click="vm.f.delCustomizeSearchKey(key)">Delete</a> <a ng-href="rfq-search-list.html?key={{key}}" class="my-search-info"><span class="my-search-keyword" ng-bind="key"></span> <span class="my-search-detail">&gt;</span></a></li></ul></li><li class="my-search-divider"></li><li class="bc-brh-my-search-c-footer"><a href="//service.alibaba.com/supplier/faq_detail/14382553.htm?tracelog=sourcing_home" target="_blank">如何使用“我定制的搜索”</a></li></ul></div></div></div>',
            bindings: {
                customizeSearchKey: '=', // 定制搜索词
                reloadCustomizeSearchKey: '<' // 是否重新加载定制搜索词
            },
            controllerAs: 'vm',
            controller: rfqSearchCtrl
        });

    function rfqSearchCtrl(request, rfqLoadAccInfoFactory) {

        this.$onChanges = bindingsOnChanges;
        this.$onInit = onInit;

        var vm = this;
        var SEARCH_RESULT_URL = "/rfq-search-list.html?key=";

        vm.d = {
            searchKey: '',
            customizeSearchKey: []
        };

        vm.f = {
            searchBusiness: searchBusiness,
            enterSearchBusiness: enterSearchBusiness,
            delCustomizeSearchKey: delCustomizeSearchKey
        };

        function onInit() {
            console.log('[rfqSearchComponent init: ]');
            vm.d.searchKey = DSSX.util.queryString('key') || '';
            rfqLoadAccInfoFactory.start('rfqCustomSearchTexts', true)
                .then(function (res) {
                    vm.d.customizeSearchKey = res.customizeSearchKey;
                    vm.customizeSearchKey = vm.d.customizeSearchKey;
                    vm.reloadCustomizeSearchKey = false;
                })
        }

        function bindingsOnChanges(change) {

            if (change.reloadCustomizeSearchKey) {
                if (vm.reloadCustomizeSearchKey) {
                    rfqLoadAccInfoFactory.start('rfqCustomSearchTexts', false)
                        .then(function (res) {
                            vm.d.customizeSearchKey = res.customizeSearchKey;
                            vm.customizeSearchKey = vm.d.customizeSearchKey;
                            vm.reloadCustomizeSearchKey = false;
                        })
                }
            }
        }

        // 回车搜索
        function enterSearchBusiness(e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode === 13) {
                searchBusiness();
            }
        }

        // 搜索商机
        function searchBusiness() {

            var searchKey = vm.d.searchKey;
            var reg = /[^a-zA-Z0-9\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F\s]/;

            if (!searchKey) {
                alert('Please input a search term.');
                return;
            }

            if (reg.test(searchKey)) {
                layer.msg("Sorry,the information you filled in is not in English.\nPlace input the information in English instead");
                return;
            }
            window.location.href = SEARCH_RESULT_URL + encodeURIComponent(searchKey).toLocaleLowerCase();
        }

        // 删除定制搜索
        function delCustomizeSearchKey(key) {

            var beDelKeys = [];
            beDelKeys.push(key);

            var data = {
                rfqCustomSearchTexts: beDelKeys
            };

            return request.post('/usr/api/updateAccInfo', {upSrhTxtMethod: 'del'}, data, true)
                .then(callback, errCallback);

            function callback(res) {
                layer.msg('刪除成功');
                rfqLoadAccInfoFactory.start('rfqCustomSearchTexts', false)
                    .then(function (res) {
                        vm.d.customizeSearchKey = res.customizeSearchKey;
                        vm.customizeSearchKey = vm.d.customizeSearchKey;
                        vm.reloadCustomizeSearchKey = false;
                    })
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: '搜索组件',
                    funcName: 'delCustomizeSearchKey',
                    text: '刪除定制搜索失败'
                });
            }
        }
    }
})();